// ** Modules
import { gql, type TypedDocumentNode } from '@apollo/client';

// ** Utils
import {
	Anchor,
	CtaFields,
	TeamBlock,
	HeroBlock,
	FileBlock,
	TextBlock,
	NewsBlock,
	VideoBlock,
	FileFields,
	TextEditor,
	ImageBlock,
	EventsBlock,
	MediaFields,
	PersonBlock,
	CardsRowBlock,
	ButtonBlock,
	SearchFilter,
	WYSISYGBlock,
	PartnerBlock,
	GraphicBlock,
	PodcastBlock,
	CarouselBlock,
	BildTextBlock,
	ImageGridCard,
	AccordionGroup,
	ImageGridBlock,
	AccordionCards,
	AccordionCardItem,
	DashboardOverview,
	RecursivePageLink,
	ButtonLinkRowBlock,
	// EhrenamtFileFields,
	GridNavigationBlock,
	ImageElementContent,
	RelevantPersonFields,
	FragmentEhrenamtBlock,
	CompetitionCardsBlock,
	CompetitionCardItem,
	CompetitionCardExtraImage
} from './fragments';

// ** Types
import type { Query } from '@/types/graphql';

export const pagesQuery: TypedDocumentNode<
	Pick<Query, 'pages'>,
	{
		slug: string;
		locale?: string;
		status?: string;
	}
> = gql`
	${Anchor}
	${CtaFields}
	${TeamBlock}
	${HeroBlock}
	${FileBlock}
	${TextBlock}
	${NewsBlock}
	${VideoBlock}
	${FileFields}
	${TextEditor}
	${ImageBlock}
	${EventsBlock}
	${MediaFields}
	${PersonBlock}
	${ButtonBlock}
	${SearchFilter}
	${WYSISYGBlock}
	${PartnerBlock}
	${GraphicBlock}
	${PodcastBlock}
	${CarouselBlock}
	${BildTextBlock}
	${ImageGridCard}
	${CardsRowBlock}
	${AccordionGroup}
	${ImageGridBlock}
	${AccordionCards}
	${AccordionCardItem}
	${DashboardOverview}
	${RecursivePageLink}
	${ButtonLinkRowBlock}
	${CompetitionCardItem}
	${GridNavigationBlock}
	${ImageElementContent}
	${RelevantPersonFields}
	${FragmentEhrenamtBlock}
	${CompetitionCardsBlock}
	${CompetitionCardExtraImage}

	query getPageBySlug($slug: String!, $locale: I18NLocaleCode) {
		pages(filters: { slug: { eq: $slug } }, locale: $locale) {
			__typename
			title
			active
			pageTags {
				name
				slug
			}
			authenticated
			pageDescription
			pageRestrictedToGroups
			isNewsLandingPage
			isEventsLandingPage
			pageHero {
				...HeroBlock
			}
			pageContent {
				__typename
				...Anchor
				...TextBlock
				...TeamBlock
				...FileBlock
				...NewsBlock
				...ImageBlock
				...VideoBlock
				...EventsBlock
				...PersonBlock
				...CardsRowBlock
				...ButtonBlock
				...WYSISYGBlock
				...GraphicBlock
				...PodcastBlock
				...PartnerBlock
				...CarouselBlock
				...BildTextBlock
				...ImageGridBlock
				...AccordionGroup
				...AccordionCards
				...DashboardOverview
				...ButtonLinkRowBlock
				...GridNavigationBlock
				...FragmentEhrenamtBlock
				...CompetitionCardsBlock
			}
			... on Page {
				...RecursivePageLink
			}
		}
	}
`;

export const discoveryPagesQuery: TypedDocumentNode<
	Pick<Query, 'pages'>,
	{
		locale?: string;
		filters?: Record<string, any>;
	}
> = gql`
	query discoveryPages($locale: I18NLocaleCode, $filters: PageFiltersInput) {
		pages(locale: $locale, filters: $filters) {
			documentId
			slug
			isNewsLandingPage
			isEventsLandingPage
			isUserLandingPage
			authenticated
			parent_page {
				slug
				parent_page {
					slug
					parent_page {
						slug
					}
				}
			}
		}
	}
`;
